import {request,request2} from './request'
export function getnavinfo(name,index){
	return request2({
		url:'/api/iteminfo',
		headers: {
			'Content-Type':'application/x-www-form-urlencoded;charset=utf-8',
		},
		params:{
			name,
			index
		}
	})
}

export function getnavinfo2(name){
	return request2({
		url:'/api/iteminfo2',
		headers: {
			'Content-Type':'application/x-www-form-urlencoded;charset=utf-8',
		},
		params:{
			name
		}
	})
}